<template>
	<div class="download-page">
		<!-- 紧凑型 Banner -->
		<div class="dl-banner">
			<div class="dl-banner-content">
				<div class="dl-banner-left">
					<h1 class="dl-banner-title">下载特规通 App</h1>
					<p class="dl-banner-subtitle">Android 端已上线各大应用商店，随时随地、合规无忧</p>
				</div>
			</div>
		</div>

		<!-- 最新版本信息 -->
		<section class="dl-section">
			<div class="dl-container">
				<div class="dl-version-card">
					<div class="dl-version-glow"></div>
					<div class="dl-version-content">
						<div class="dl-version-left">
							<div class="dl-version-icon" :class="{ 'is-downloading': apkLoading }" @click="downloadApk">
								<i class="el-icon-download"></i>
							</div>
							<div class="dl-version-info">
								<span class="dl-version-label">安卓最新版本</span>
								<span class="dl-version-number">v{{ latestVersion.appVersion }}</span>
							</div>
						</div>
						<div class="dl-version-right">
							<div class="dl-version-meta">
								<span class="dl-version-meta-item" v-if="latestVersion && latestVersion.createTime">
									<i class="el-icon-date"></i>
									发布时间：{{ latestVersion.createTime ? latestVersion.createTime.substring(0, 16) : '' }}
								</span>
								<span class="dl-version-meta-item" v-if="latestVersion && latestVersion.remark">
									<i class="el-icon-document-copy"></i>
									更新内容：{{ latestVersion.remark }}
								</span>
							</div>
						</div>
					</div>
				</div>
			</div>
		</section>

		<!-- 平台选择下载 -->
		<section class="dl-section dl-section-platforms">
			<div class="dl-container">
				<div class="dl-section-header">
					<h2>选择您的平台</h2>
					<p>根据您的设备类型，选择对应的下载方式</p>
				</div>

				<div class="dl-platforms-grid">
					<!-- Android -->
					<div class="dl-platform-card dl-platform-android">
						<div class="dl-platform-icon-wrap">
							<svg class="dl-platform-svg" viewBox="0 0 24 24" width="48" height="48" fill="currentColor">
								<path
									d="M6 18C6 18.55 6.45 19 7 19H8V22.5C8 23.33 8.67 24 9.5 24S11 23.33 11 22.5V19H13V22.5C13 23.33 13.67 24 14.5 24S16 23.33 16 22.5V19H17C17.55 19 18 18.55 18 18V8H6V18ZM3.5 8C2.67 8 2 8.67 2 9.5V16.5C2 17.33 2.67 18 3.5 18S5 17.33 5 16.5V9.5C5 8.67 4.33 8 3.5 8ZM20.5 8C19.67 8 19 8.67 19 9.5V16.5C19 17.33 19.67 18 20.5 18S22 17.33 22 16.5V9.5C22 8.67 21.33 8 20.5 8ZM15.53 2.16L16.84 0.85C16.94 0.75 17 0.63 17 0.5C17 0.22 16.78 0 16.5 0C16.37 0 16.25 0.06 16.15 0.15L14.77 1.53C13.67 0.97 12.37 0.65 11 0.65C9.63 0.65 8.33 0.97 7.23 1.53L5.85 0.15C5.75 0.06 5.63 0 5.5 0C5.22 0 5 0.22 5 0.5C5 0.63 5.06 0.75 5.15 0.85L6.47 2.16C4.54 3.17 3.18 5.06 2.76 7.29H21.24C20.82 5.06 19.46 3.17 17.53 2.16H15.53Z"
								/>
							</svg>
						</div>
						<h3 class="dl-platform-name">Android</h3>
						<p class="dl-platform-desc">支持各大应用商店下载，或直接下载 APK 安装包</p>

						<!-- 应用商店入口 -->
						<div class="dl-stores">
							<span class="dl-stores-label">已上线平台 · 应用商店下载</span>
							<div class="dl-stores-list">
								<a v-for="store in androidStores" :key="store.name" class="dl-store-link">
									{{ store.name }}
								</a>
							</div>
							<div class="dl-store-soon">
								<i class="el-icon-time"></i>
								华为应用市场暂未上线，敬请期待
							</div>
						</div>

						<!-- 直接下载 APK -->
						<div class="dl-platform-action">
							<el-button class="dl-btn-android" size="medium" :loading="apkLoading" @click="downloadApk"> <i class="el-icon-download"></i> 直接下载 APK </el-button>
						</div>
						<div class="dl-platform-note">
							<i class="el-icon-info"></i>
							<span>APK 版本 {{ latestVersion.appVersion }}，请允许安装未知来源应用</span>
						</div>
					</div>

					<!-- iOS / Apple -->
					<div class="dl-platform-card dl-platform-ios">
						<div class="dl-platform-icon-wrap">
							<svg class="dl-platform-svg" viewBox="0 0 24 24" width="48" height="48" fill="currentColor">
								<path
									d="M18.71 19.5C17.88 20.74 17 21.95 15.66 21.97C14.32 21.99 13.89 21.18 12.37 21.18C10.84 21.18 10.37 21.95 9.1 21.99C7.79 22.03 6.8 20.68 5.96 19.47C4.25 16.97 2.94 12.45 4.7 9.39C5.57 7.87 7.13 6.91 8.82 6.88C10.1 6.86 11.32 7.75 12.11 7.75C12.89 7.75 14.37 6.68 15.92 6.84C16.57 6.87 18.39 7.1 19.56 8.82C19.47 8.88 17.39 10.1 17.41 12.63C17.44 15.65 20.06 16.66 20.09 16.67C20.06 16.74 19.67 18.11 18.71 19.5ZM13 3.5C13.73 2.67 14.94 2.04 15.94 2C16.07 3.17 15.6 4.35 14.9 5.19C14.21 6.04 13.07 6.7 11.95 6.61C11.8 5.46 12.36 4.26 13 3.5Z"
								/>
							</svg>
						</div>
						<h3 class="dl-platform-name">iOS / 鸿蒙</h3>
						<p class="dl-platform-desc">iOS（iPhone / iPad）与鸿蒙系统（HarmonyOS）暂未上线，敬请期待</p>
						<div class="dl-platform-action">
							<span class="dl-platform-soon"><i class="el-icon-time"></i> 暂未上线 · 敬请期待</span>
						</div>
						<div class="dl-platform-note dl-platform-note-tip">
							<i class="el-icon-info"></i>
							<span>建议关注「特规通」平台或公众号获取标准最新资讯；或暂在已上线的 Android 设备上使用完整功能</span>
						</div>
					</div>
				</div>
			</div>
		</section>

		<!-- 安装指南 -->
		<section class="dl-section dl-section-guide">
			<div class="dl-container">
				<div class="dl-section-header">
					<h2>APK 下载到安装流程（共 6 步）</h2>
					<p>适用于未覆盖在上述应用商店中的 Android 设备，例如部分小众品牌机型、海外版 Android 手机、未预装对应商店的设备等</p>
				</div>
				<div class="dl-guide-steps">
					<div class="dl-guide-step" v-for="(step, index) in installSteps" :key="index">
						<div class="dl-guide-step-num">{{ index + 1 }}</div>
						<div class="dl-guide-step-content">
							<h4>{{ step.title }}</h4>
							<p>{{ step.desc }}</p>
						</div>
					</div>
				</div>
				<div class="dl-guide-note">
					<i class="el-icon-warning-outline"></i>
					<p>注：不同浏览器 / 系统版本的安装拦截文案略有差异，部分设备会改为在“设置 → 安全”中开启“允许安装未知应用”后重试，流程本质一致。</p>
				</div>
			</div>
		</section>
	</div>
</template>

<script>
	import User from '@/utils/User.js';
	import { getAppVersion } from '@/api/apk/index.js';
	export default {
		name: 'DownloadPage',
		data() {
			return {
				latestVersion: {
					appVersion: '1.0.0',
					releaseDate: '2026-09-01',
					changelog: '首个正式版本发布，支持标准查询、AI 问答、资料库管理'
				},
				apkLoading: false,
				androidStores: [
					{ name: '小米应用商店', url: 'https://app.mi.com/' },
					{ name: 'OPPO 软件商店', url: 'https://store.oppo.com/' },
					{ name: 'vivo 应用商店', url: 'https://dev.vivo.com/' },
					{ name: '荣耀应用市场', url: 'https://www.honor.com/cn/appmarket/' },
					{ name: '应用宝', url: 'https://sj.qq.com/' }
				],
				installSteps: [
					{
						title: '进入官方下载页',
						desc: '在手机浏览器中打开特规通官方下载页'
					},
					{
						title: '下载安装包',
						desc: '点击「下载 APK」，等待下载完成（文件默认保存在「下载 / Download」目录）'
					},
					{
						title: '打开安装包，触发安全提醒',
						desc: '点击通知栏中的已下载文件，或在手机「文件管理」中找到 .apk 文件并打开。浏览器会弹出“XX浏览器正在尝试安装应用”提醒，提示“本次安装的应用由第三方应用提供……”'
					},
					{
						title: '确认继续',
						desc: '点击「继续」，再次弹出关于「未知风险」的安全提醒，点击「允许」'
					},
					{
						title: '单次授权安装',
						desc: '随后弹出安装选项页（含「应用商店安装」「取消安装」），点击右上角的「单次授权安装」（同页还提供「举报该应用」「设置」）'
					},
					{
						title: '完成安装并打开',
						desc: '授权后自动完成安装，点击「打开」即可进入特规通 App'
					}
				]
			};
		},
		created() {
			this.getAppVersion();
		},
		methods: {
			downloadApk() {
				// 下载互斥：任意一处入口下载进行中，重复点击均给出提示
				if (this.apkLoading) {
					this.$message.info('正在下载，请稍等');
					return;
				}
				this.getAppDownload();
			},

			// 通用文件下载方法（参考 BookOrder.vue downloadFile）
			downloadFile(blob, filename, type) {
				const url = URL.createObjectURL(blob);
				const link = document.createElement('a');
				link.href = url;
				link.download = filename;
				link.style.display = 'none';
				document.body.appendChild(link);
				link.click();
				document.body.removeChild(link);
				URL.revokeObjectURL(url); // 释放内存
				this.$message.success(type + '下载成功！');
			},
			// 下载 APK：mockjs 会劫持 XHR 且不同步 responseType，axios 的 blob 会退化成二进制字符串
			// 因此改用 fetch 获取文件流（参考 BookOrder.vue handleDownloadInvoice 的下载逻辑）
			async getAppDownload() {
				this.apkLoading = true;
				try {
					const headers = {
						Authorization: 'Bearer ' + User.getToken()
					};
					const cinfo = User.getCorporate();
					if (cinfo) {
						headers['corporate-id'] = cinfo.corporateId;
					}

					const response = await fetch('/webL_api/essential/api/appDownload/0', { headers });
					if (!response.ok) {
						throw new Error(`HTTP error! status: ${response.status}`);
					}

					// 后端出错时可能返回 JSON 错误信息（如 {"code":500,"msg":"..."}）
					const contentType = response.headers.get('Content-Type') || '';
					if (contentType.indexOf('application/json') !== -1) {
						const err = await response.json();
						this.$message.error((err && err.msg) || '下载失败，请稍后重试');
						return;
					}

					const arrayBuffer = await response.arrayBuffer();
					const blob = new Blob([arrayBuffer], { type: 'application/vnd.android.package-archive' });

					// 触发浏览器下载
					this.downloadFile(blob, `${this.latestVersion.appVersion}.apk`, 'APK');
				} catch (error) {
					console.error('获取 APK 失败:', error);
					this.$message.error('获取 APK 下载链接失败');
				} finally {
					this.apkLoading = false;
				}
			},

			getAppVersion() {
				getAppVersion().then(res => {
					if (res.code == 200) {
						this.latestVersion = res.data;
					}
				});
			}
		}
	};
</script>

<style scoped lang="less">
	// ========== 配色变量 ==========
	@color-primary: #2563eb;
	@color-indigo: #4f46e5;
	@color-bg: #f8fafc;
	@color-text: #1e293b;
	@color-subtext: #64748b;
	@color-muted: #94a3b8;

	// ========== 页面容器 ==========
	.download-page {
		background: @color-bg;
		min-height: 100vh;
	}

	.dl-container {
		max-width: 1080px;
		margin: 0 auto;
		padding: 0 24px;
	}

	// ========== 紧凑型 Banner（紫蓝主题色） ==========
	.dl-banner {
		background: linear-gradient(to right, #2563eb, #6366f1);
		color: #ffffff;
		padding: 32px 0;
	}

	.dl-banner-content {
		width: 70%;
		margin: 0 auto;
		display: flex;
		align-items: center;
		justify-content: space-between;
	}

	.dl-banner-left {
		width: 100%;
		flex: 0 0 auto;
	}

	.dl-banner-title {
		font-size: 20px;
		font-weight: 700;
		margin: 0 0 4px;
		line-height: 1.3;
	}

	.dl-banner-subtitle {
		font-size: 14px;
		color: rgba(255, 255, 255, 0.8);
		line-height: 1.5;
		margin: 0;
	}

	.dl-section {
		padding-bottom: 60px;
	}

	.dl-section-header {
		text-align: center;
		margin-bottom: 40px;

		h2 {
			font-size: 28px;
			font-weight: 700;
			color: @color-text;
			margin: 0 0 10px;
		}

		p {
			font-size: 15px;
			color: @color-subtext;
			margin: 0;
		}
	}

	// ========== 版本信息卡片 ==========
	.dl-version-card {
		position: relative;
		margin-top: 60px;
		background: #ffffff;
		border-radius: 20px;
		padding: 32px 36px;
		box-shadow: 0 4px 24px rgba(0, 0, 0, 0.08), 0 0 0 1px rgba(0, 0, 0, 0.04);
		overflow: hidden;
		z-index: 2;
	}

	.dl-version-glow {
		position: absolute;
		top: -60px;
		right: -60px;
		width: 200px;
		height: 200px;
		background: radial-gradient(circle, rgba(37, 99, 235, 0.08) 0%, transparent 70%);
		border-radius: 50%;
		pointer-events: none;
	}

	.dl-version-content {
		position: relative;
		display: flex;
		align-items: center;
		justify-content: space-between;
		flex-wrap: wrap;
		gap: 40px;
	}

	.dl-version-left {
		display: flex;
		align-items: center;
		gap: 18px;
	}

	.dl-version-icon {
		width: 56px;
		height: 56px;
		border-radius: 16px;
		background: linear-gradient(135deg, @color-primary, @color-indigo);
		display: flex;
		align-items: center;
		justify-content: center;
		cursor: pointer;

		&.is-downloading {
			opacity: 0.6;
			pointer-events: none;
			cursor: not-allowed;
		}

		i {
			font-size: 28px;
			color: #ffffff;
		}
	}

	.dl-version-label {
		display: block;
		font-size: 13px;
		color: @color-muted;
		margin-bottom: 4px;
		text-transform: uppercase;
		letter-spacing: 1px;
	}

	.dl-version-number {
		display: block;
		font-size: 28px;
		font-weight: 800;
		color: @color-text;
		letter-spacing: -0.5px;
	}

	.dl-version-right {
		flex: 1;
		min-width: 260px;
	}

	.dl-version-meta {
		display: flex;
		flex-direction: column;
		gap: 8px;
	}

	.dl-version-meta-item {
		display: flex;
		align-items: center;
		gap: 8px;
		font-size: 14px;
		color: @color-subtext;

		i {
			color: @color-primary;
			font-size: 16px;
		}
	}

	// ========== 平台选择 ==========
	.dl-section-platforms {
		padding-top: 20px;
	}

	.dl-platforms-grid {
		display: grid;
		grid-template-columns: repeat(2, 1fr);
		gap: 28px;
	}

	.dl-platform-card {
		background: #ffffff;
		border-radius: 20px;
		padding: 40px 32px;
		text-align: center;
		box-shadow: 0 1px 3px rgba(0, 0, 0, 0.06), 0 4px 12px rgba(0, 0, 0, 0.04);
		border: 1px solid #f1f5f9;
		transition: all 0.3s ease;
		position: relative;
		overflow: hidden;

		&:hover {
			transform: translateY(-4px);
			box-shadow: 0 12px 32px rgba(0, 0, 0, 0.1);
		}

		&::before {
			content: '';
			position: absolute;
			top: 0;
			left: 0;
			right: 0;
			height: 4px;
		}
	}

	.dl-platform-ios::before {
		background: linear-gradient(90deg, #6366f1, #8b5cf6, #a78bfa);
	}

	.dl-platform-android::before {
		background: linear-gradient(90deg, #22c55e, #10b981, #34d399);
	}

	.dl-platform-icon-wrap {
		width: 80px;
		height: 80px;
		margin: 0 auto 20px;
		border-radius: 20px;
		display: flex;
		align-items: center;
		justify-content: center;
		transition: transform 0.3s ease;

		.dl-platform-card:hover & {
			transform: scale(1.08);
		}

		.dl-platform-ios & {
			background: linear-gradient(135deg, rgba(99, 102, 241, 0.12), rgba(139, 92, 246, 0.12));
			color: #6366f1;
		}

		.dl-platform-android & {
			background: linear-gradient(135deg, rgba(34, 197, 94, 0.12), rgba(16, 185, 129, 0.12));
			color: #22c55e;
		}
	}

	.dl-platform-svg {
		display: block;
	}

	.dl-platform-name {
		font-size: 22px;
		font-weight: 700;
		color: @color-text;
		margin: 0 0 10px;
	}

	.dl-platform-desc {
		font-size: 14px;
		color: @color-subtext;
		line-height: 1.6;
		margin: 0 0 24px;
	}

	.dl-platform-action {
		margin-bottom: 16px;
	}

	.dl-platform-soon {
		display: inline-flex;
		align-items: center;
		gap: 6px;
		background: #f1f5f9;
		border: 1px dashed #cbd5e1;
		color: #94a3b8;
		border-radius: 12px;
		padding: 12px 28px;
		font-size: 15px;
		font-weight: 600;
		letter-spacing: 1px;
	}

	.dl-btn-android {
		background: linear-gradient(135deg, #22c55e, #10b981) !important;
		border: none !important;
		color: #ffffff !important;
		border-radius: 12px !important;
		padding: 12px 28px !important;
		font-size: 15px !important;
		font-weight: 600 !important;
		transition: all 0.3s ease !important;

		&:hover {
			box-shadow: 0 6px 20px rgba(34, 197, 94, 0.4);
			transform: translateY(-2px);
		}
	}

	.dl-platform-note {
		display: inline-flex;
		align-items: center;
		gap: 6px;
		font-size: 12px;
		color: @color-muted;
		background: #f8fafc;
		padding: 8px 14px;
		border-radius: 8px;

		i {
			font-size: 14px;
		}
	}

	// 长文本提示（iOS / 鸿蒙卡）左对齐
	.dl-platform-note-tip {
		text-align: left;
		line-height: 1.6;
		align-items: flex-start;

		i {
			margin-top: 2px;
		}
	}

	// ========== 应用商店 ==========
	.dl-stores {
		margin-bottom: 20px;
	}

	.dl-stores-label {
		font-size: 13px;
		color: @color-subtext;
		display: block;
		margin-bottom: 10px;
	}

	.dl-stores-list {
		display: flex;
		flex-wrap: wrap;
		justify-content: center;
		gap: 10px;
		width: 80%;
		margin: 0 auto;
	}

	.dl-store-link {
		display: inline-block;
		color: @color-text;
		text-decoration: none;
		font-weight: 500;
		transition: all 0.2s ease;
		padding: 6px 14px;
		background: #f1f5f9;
		border-radius: 8px;
		font-size: 12px;
	}

	// 未上线商店提示（华为）
	.dl-store-soon {
		margin-top: 12px;
		display: inline-flex;
		align-items: center;
		gap: 6px;
		font-size: 12px;
		color: @color-muted;
		background: #fafbfc;
		border: 1px dashed #e2e8f0;
		padding: 6px 14px;
		border-radius: 8px;

		i {
			font-size: 13px;
		}
	}

	// ========== 安装指南 ==========
	.dl-section-guide {
		padding-top: 30px;
	}

	.dl-guide-steps {
		display: grid;
		grid-template-columns: repeat(3, 1fr);
		gap: 20px;
	}

	.dl-guide-step {
		background: #ffffff;
		border-radius: 16px;
		padding: 28px 20px;
		text-align: left;
		box-shadow: 0 1px 3px rgba(0, 0, 0, 0.04), 0 4px 12px rgba(0, 0, 0, 0.04);
		border: 1px solid #f1f5f9;
		transition: box-shadow 0.3s ease, transform 0.3s ease;

		&:hover {
			box-shadow: 0 8px 25px rgba(0, 0, 0, 0.1);
			transform: translateY(-3px);
		}
	}

	.dl-guide-step-num {
		width: 40px;
		height: 40px;
		border-radius: 12px;
		background: linear-gradient(135deg, @color-primary, @color-indigo);
		color: #ffffff;
		font-size: 18px;
		font-weight: 700;
		display: flex;
		align-items: center;
		justify-content: center;
		margin: 0 0 16px;
	}

	.dl-guide-step-content {
		h4 {
			font-size: 16px;
			font-weight: 700;
			color: @color-text;
			margin: 0 0 8px;
		}

		p {
			font-size: 13px;
			color: @color-subtext;
			line-height: 1.6;
			margin: 0;
		}
	}

	// ========== 安装流程注意事项（注） ==========
	.dl-guide-note {
		display: flex;
		align-items: flex-start;
		gap: 12px;
		margin-top: 24px;
		background: linear-gradient(135deg, #fffbeb, #fef3c7);
		border: 1px solid #fde68a;
		border-left: 4px solid #f59e0b;
		border-radius: 12px;
		padding: 16px 20px;

		i {
			font-size: 18px;
			color: #d97706;
			margin-top: 2px;
			flex-shrink: 0;
		}

		p {
			font-size: 13px;
			color: #92400e;
			line-height: 1.7;
			margin: 0;
		}
	}

	// ========== 响应式 ==========
	@media (max-width: 768px) {
		.dl-platforms-grid {
			grid-template-columns: 1fr;
		}

		.dl-guide-steps {
			grid-template-columns: repeat(2, 1fr);
		}

		.dl-version-content {
			flex-direction: column;
			text-align: center;
		}

		.dl-version-left {
			flex-direction: column;
		}

		.dl-version-meta {
			align-items: center;
		}
	}

	@media (max-width: 480px) {
		.dl-guide-steps {
			grid-template-columns: 1fr;
		}

		.dl-version-card {
			padding: 24px 20px;
		}
	}
</style>
